// Contrat avec mfe-transaction : le détail d'une transaction pose cette clé avant de revenir
// à la liste (markRestoreIntent), pour que la liste restaure son défilement. Le Layout du host
// doit alors s'abstenir de remettre le scroll à zéro. Garder la clé alignée avec le MFE.
const INTENT_KEY = 'transactions:restoreIntent';

export function hasRestoreIntent(): boolean {
  return sessionStorage.getItem(INTENT_KEY) === '1';
}
